import { AlertTriangle, Info } from 'lucide-react';
import { forwardRef } from 'react';
import { cn } from 'v5/platform/dom/cn';

export type InfoCalloutProps = React.ComponentPropsWithRef<'div'> & {
  icon?: React.ReactNode | false;
  /** `attention`: a warning, with the warning triangle as its default icon. */
  tone?: 'info' | 'attention';
};

export const InfoCallout = forwardRef<HTMLDivElement, InfoCalloutProps>(
  ({ className, children, icon, tone = 'info', ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex gap-2 rounded-md border p-4 text-sm',
        tone === 'info' && 'border-border-accent bg-bg-accent',
        tone === 'attention' &&
          'border-border-attention bg-bg-attention dark:border-border-attention-emphasis/35 dark:bg-bg-attention-emphasis/12',
        className
      )}
      {...rest}
    >
      {icon === false
        ? null
        : (icon ??
          (tone === 'attention' ? (
            <AlertTriangle
              className="size-5 shrink-0 text-fg-attention"
              aria-hidden
            />
          ) : (
            <Info className="size-5 shrink-0" aria-hidden />
          )))}
      <div className="min-w-0">{children}</div>
    </div>
  )
);

InfoCallout.displayName = 'InfoCallout';
